<template>
  <div>
    <div class="back" v-if="isVisible"></div>
    <transition name="slide">
      <div class="excel_container" v-if="isVisible" @click="hideHistory">
        <div class="excel_header_view">
          <div class="excel_header_view_tite">{{ jsonData.filename.split('.')[0] }}<i class="el-icon-circle-close" @click="hideModal"></i></div>
          <el-tabs type="card" v-model="activeSheet" lazy>
            <el-tab-pane 
              v-for="(item, index) in jsonData.items"
              :key="index"
              :label="item.sheetName"
              :name="item.sheetName"
            >
              <div v-show="activeSheet === item.sheetName">
                <!-- 添加操作按钮 -->
                <div class="table-operations" style="margin-bottom: 10px;" v-if="disabledBtn === false">
                  <div class="add-row-btn" @click="addRow(item)">{{ $t('excel.add') }}</div>
                  <div class="delete-row-btn" @click="deleteSelectedRows(item)">{{ $t('excel.delete') }}</div>
                </div>
                <el-table
                  :data="item.data"
                  border
                  :key="'table-' + activeSheet"
                  :loading="excelLoading"
                  class="excel_table"
                  style="width: 100%;"
                  height="100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                  @selection-change="handleSelectionChange(item, $event)"
                >
                  <el-table-column type="selection" width="40"></el-table-column>
                  <el-table-column
                    v-for="(header, index) in item.headers"
                    :key="index"
                    :prop="header"
                    :label="header"
                    align="center"
                    :filters="header === '活动地点' || header === 'Activity place' ? filterData() : null"
                    :filter-method="header === '活动地点' || header === 'Activity place' ? handleFilter : null"
                    filter-placement="bottom-end"
                    :class-name="header === 'Description' ? 'description-cell' : ''">
                    <template slot-scope="{ row }">
                      <template v-if="['排放源类别','Category(scope 3)','活动地点','Activity place'].includes(header)">
                        <el-select :disabled="disabledBtn" v-model="row[header]" size="small" style="width: 100%; border: none;">
                          <el-option v-for="opt in getOptions(header, item)" :label="opt" :value="opt" :key="opt"/>
                        </el-select>
                      </template>
                      <template v-else>
                        <el-tooltip class="item" effect="dark" :disabled="row[header] == null || row[header] == ''" :content="row[header]" :open-delay="300" placement="top">
                          <el-input 
                            v-model="row[header]"
                            size="small"
                            :disabled="disabledBtn"
                             @input="handleInputChange(header, row, $event)"
                            style="width: 100%; border: none;"
                          ></el-input>
                        </el-tooltip>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="historyView" v-if="showHistory">
                <div v-if="historyLoading" class="history-loading">
                  <i class="el-icon-loading"></i>
                  <span>正在加载历史记录...</span>
                </div>
                <div v-else>
                  <div 
                    class="historyView_item" 
                    v-for="(item, index) in historyData" 
                    :key="index"
                    @click="showHistoryDetail(item.id)"  
                  >
                    <span>{{ $dayjs(item.createTime).format('YYYY-MM-DD') }}</span>
                    <span>历史版本:{{ item.version }}</span>
                  </div>
                  <div v-if="historyData.length === 0" class="history-empty">
                    暂无历史记录
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('excel.history')" class="history-tab" name="history" :disabled="true">
              <template #label>
                <span @click.stop="showHistoryTab">{{ $t('excel.history') }}</span>
              </template>
              {{ $t('excel.history') }}
            </el-tab-pane>
          </el-tabs>
          <div class="excel_footer_view" v-if="disabledBtn === false">
            <div :class="{ 'is-loadExcel': isloadExcel }" class="download-btn" @click="downloadExcel">{{isloadExcel ? $t('excel.downloadExcelting') : $t('excel.downloadExcel')}}</div>
            <div :class="{ 'is-submitting': isSubmitting }" class="download-btn" @click="submitCollectForm">{{ isSubmitting ?  $t('excel.submitting') :  $t('excel.submit') }}</div>
            <div class="download-btn" @click="saveDraft">{{ $t('excel.save') }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { t } from 'element-ui/lib/locale';
import ExcelJS from 'exceljs';
import { 
  getCustomUiConfig,
  getHistoryJsonContent, 
  getHistoryJsonContentDetail,
  saveVersion 
} from '@/api/index';
import { get } from 'store';

export default {
  name: 'ExcelViewer',
  data() {
    return {
      isVisible: false,
      activeSheet: '',
      selectedRows: {}, // 存储每个sheet的选中行
      fileId: '',
      jsonData: {},
      excelLoading: false,
      historyData: [],
      showHistory: false,
      originalData: {}, // 保存原始数据用于比较
      historyLoading: false,
      disabledBtn: false, // 是否禁用按钮
      isSubmitting: false,
      isloadExcel: false,
    }
  },
  // computed: {
  //   headers() {
  //     return this.jsonData.items[0].headers || [];
  //   },
  //   tableData() {
  //     return this.jsonData.items[0].data || [];
  //   },
  //   filteredData() {
  //     return this.tableData.filter(item => 
  //       Object.values(item).some(val => val && val.toString().trim() !== '')
  //     );
  //   }
  // },
  mounted() {
    // this.loadData()
    this.$nextTick(() => {
      this.setDefaultActiveSheet();
    });
  },
  methods: {
    getOptions(header, item) {
      if (['排放源类别', 'Category(scope 3)'].includes(header)) {
        return item.type_options || [];
      } else if (['活动地点', 'Activity place'].includes(header)) {
        return this.jsonData.activity_options || [];
      }
      return [];
    },

    filterData() {
      // 从jsonData获取活动地点选项并格式化为{text, value}结构
      return this.jsonData.activity_options?.map(item => ({ 
        text: item, 
        value: item 
      })) || [];
    },

    // 筛选逻辑处理方法
    handleFilter(value, row) {
      // 直接比较活动地点字段与筛选值
      return row['活动地点'] === value || row['Activity place'] === value;
    },

    // 处理输入框变化
    handleInputChange(header, row, value) {
      if (['数量', 'Quantity'].includes(header) || ['运输距离', 'Transportation distance'].includes(header)) {
        // 允许输入数字和小数点，但只能有一个小数点
        let filteredValue = value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
        // 防止0作为开头（除非是0.xxx或0本身）
        if (filteredValue.length > 1 && filteredValue.startsWith('0') && !filteredValue.startsWith('0.')) {
          filteredValue = filteredValue.substring(1);
        }
        this.$set(row, header, filteredValue);
      }
    },

    // 设置表头
    isHeaderRow(row) {
      return row['Selection (Yes/No)'] === 'Selection (Yes/No)' || row['选择（是/否）'] === '选择（是/否）';
    },

    // 设置自定义表头
    tableRowClassName({ row }) {
      return this.isHeaderRow(row) ? 'scope-header-row' : '';
    },

    // 处理选择变化
    handleSelectionChange(sheet, rows) {
      this.$set(this.selectedRows, sheet.sheetName, rows);
    },

    // 显示历史记录标签页
    async showHistoryTab() {
      this.showHistory = false;
      this.historyLoading = true;
      try {
        await this.loadHistory();
        this.showHistory = true;
      } catch (error) {
        console.error('加载历史记录失败:', error);
        // this.$message.error('加载历史记录失败');
      } finally {
        this.historyLoading = false;
      }
    },

    // 隐藏历史记录标签页
    hideHistory() {
      if(this.showHistory){
        this.showHistory = false;
      }
    },

    // 显示历史记录详情
    showHistoryDetail(id) {
      this.hideHistory();
      this.loadHistoryDetail(id);
    },

    // 加载历史记录详情
    loadHistoryDetail(id) {
      getHistoryJsonContentDetail(id).then(response => {
        if(response.data.code == 200){
          this.jsonData = response.data.data;
          // 保存原始数据用于比较
          this.originalData = JSON.parse(JSON.stringify(this.jsonData));
          // 设置默认激活工作表
          this.setDefaultActiveSheet();
          // 清空选中状态
          this.selectedRows = {};
          this.isVisible = true;
          this.excelLoading = false;
        }else{
          this.excelLoading = false;
          this.$message.error(response.data.data);
        }
      });
    },

    // 添加行
    addRow(sheet) {
      // 创建新行对象，使用headers作为键，初始值为空
      const newRow = {};
      sheet.headers.forEach(header => {
        newRow[header] = '';
      });
      sheet.data.push(newRow);
      this.$message.success(this.$t('excel.addSuccess'));
    },

    // 删除选中行
    deleteSelectedRows(sheet) {
      const selected = this.selectedRows[sheet.sheetName] || [];
      if (selected.length === 0) {
        this.$message.warning(this.$t('excel.deleteEmpty'));
        return;
      }
      this.$confirm(`${this.$t('excel.deleteConfirm')}`, this.$t('excel.tips'), {
        confirmButtonText: this.$t('excel.confirm'),
        cancelButtonText: this.$t('excel.cancel'),
        type: 'warning'
      }).then(() => {
        // 过滤掉选中的行
        sheet.data = sheet.data.filter(row => !selected.includes(row));
        // 清空选中状态
        this.$set(this.selectedRows, sheet.sheetName, []);
        this.$message.success(this.$t('excel.deleteSuccess', { count: selected.length }));
      }).catch(() => {
      });
    },

    // 下载\导出文件免责声明
    async statement() {
      return this.$confirm(this.$t('excel.statement'), this.$t('excel.tips'), {
        confirmButtonText: this.$t('excel.confirm'),
        cancelButtonText: this.$t('excel.cancel'),
        type: 'warning'
      })
    },

    // 下载Excel文件
    async downloadExcel() {
      this.isloadExcel = true
      try {
        // await this.statement();
        const buffer = await this.submitForm();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.jsonData.filename;
        a.click();
        URL.revokeObjectURL(url);
        this.$message.success(this.$t('excel.downloadSuccess'));
        setTimeout(() => {
          this.isloadExcel = false;
        }, 1000);
      } catch (error) {
        if (error === 'cancel') {
          return;
        }else{
          this.$message.error(this.$t('excel.downloadError'));
          this.isloadExcel = false;
        }
      }
    },

    // 生成Excel文件
    async submitForm() {
      const workbook = new ExcelJS.Workbook();
      // 遍历所有工作表数据，为每个工作表创建一个sheet
      this.jsonData.items.forEach((sheetItem, sheetIndex) => {
        // 使用工作表名称或默认名称
        const sheetName = sheetItem.sheetName || `Sheet${sheetIndex + 1}`;
        const worksheet = workbook.addWorksheet(sheetName);

        // 设置表头样式
        const headerStyle = {
          font: { bold: true, color: { argb: '000000' }, size: 14 },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ADD8E6' } },
          height: 20,
          alignment: { horizontal: 'center', vertical: 'middle' },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        };

        // 设置内容样式
        const contentStyle = {
          alignment: { vertical: 'middle' },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        };

        // 添加表头 - 使用当前工作表的headers
        const headers = sheetItem.headers; // 直接使用headers数组，因为它已经是字符串数组
        worksheet.addRow(headers);
        worksheet.getRow(1).font = headerStyle.font;
        worksheet.getRow(1).fill = headerStyle.fill;
        worksheet.getRow(1).height = headerStyle.height;
        worksheet.getRow(1).alignment = headerStyle.alignment;
        worksheet.getRow(1).border = headerStyle.border;

        worksheet.columns.forEach((column, index) => {
          column.width = 25;
        });

        const sheetData = sheetItem.data;

        sheetData.forEach(row => {
          const values = sheetItem.headers.map(header => row[header]);
          const addedRow = worksheet.addRow(values);
          addedRow.alignment = contentStyle.alignment;
          addedRow.border = contentStyle.border;
        });

        // 添加下拉选择功能
        headers.forEach((header, colIndex) => {
          let options = []; //下拉选项
          if (header === '排放源类别' || header === 'Category(scope 3)') {
            options = this.jsonData.items[sheetIndex].type_options; // 下拉选项
          }else if(header === '活动地点' || header === 'Activity place'){
            options = this.jsonData.activity_options; // 下拉选项
          }else{
            return; // 如果不是需要下拉的列，直接返回
          }
          const columnLetter = String.fromCharCode(65 + colIndex); // 获取列字母(A, B, C...)
          const startRow = 2; // 从第二行开始（表头为第一行）
          const endRow = sheetData.length + 1; // 数据行数+表头行

          // 为每一行数据单元格单独设置下拉验证
          for (let row = startRow; row <= endRow; row++) {
            const cell = worksheet.getCell(`${columnLetter}${row}`);
            cell.dataValidation = {
              type: 'list',
              formulae: [`"${options.join(',')}"`],
              showDropDown: true,
              showErrorMessage: true,
              allowBlank: true,
              errorStyle: 'stop',
              errorTitle: this.$t('excel.errorTitle'),
              error: `${this.$t('excel.errorMsg')} (${options.join('/')})`
            };
          }
        });
      });
      return workbook.xlsx.writeBuffer();
    },

    // 提交收集表
    async submitCollectForm() {
      this.isSubmitting = true;
      try {
        // await this.statement();
        const buffer = await this.submitForm();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const file = new File([blob], this.jsonData.filename, { 
          type: blob.type,
          lastModified: Date.now()
        });
        this.$emit('success', file);
        setTimeout(() => {
          this.isSubmitting = false;
        }, 2000);
      } catch (error) {
        if (error === 'cancel') {
          return;
        }
        console.error('提交收集表失败:', error);
        this.isSubmitting = false;
      } 
    },

    //数据暂存
    async saveDraft(){
      saveVersion(this.fileId, this.jsonData).then(res => {
        if(res.data.code != 200){
          this.$message.error(this.$t('excel.saveDraftError'))
        }else{
          this.isVisible = false;
          this.selectedRows = {};
        }
      })
    },

    // 加载历史记录
    loadHistory() {
      return new Promise((resolve, reject) => {
        this.historyData = [];
        getHistoryJsonContent(this.fileId).then(response => {
          if(response.data.code == 200){
            this.historyData = response.data.data;
            resolve(response.data.data);
          }else{
            this.$message.error(response.data.data);
            reject(new Error(response.data.data));
          }
        }).catch(error => {
          console.error('获取历史记录失败:', error);
          reject(error);
        });
      });
    },

    // 加载数据
    loadData() {
      this.excelLoading = true;
      getCustomUiConfig(this.fileId).then(response => {
        if(response.data.code == 200){
          this.jsonData = response.data.data;
          // 保存原始数据用于比较
          this.originalData = JSON.parse(JSON.stringify(this.jsonData));
          // 设置默认激活工作表
          this.setDefaultActiveSheet();
          if(!response.data.is_latest){
            this.disabledBtn = true;
            this.$message.warning({
              message: this.$t('excel.notLatest'),
              duration: 5000
            })
          }else{
            this.disabledBtn = false;
          }
          // 清空选中状态
          this.selectedRows = {};
          this.isVisible = true;
          this.excelLoading = false;
        }else{
          this.excelLoading = false;
          this.$message.error(response.data.data);
        }
      }).catch(error => {
        console.error('获取自定义UI配置失败:', error);
      })
    },

    // 设置默认激活工作表
    setDefaultActiveSheet() {
      // 确保jsonData和items存在且不为空
      if (this.jsonData && this.jsonData.items && this.jsonData.items.length > 0) {
        // 使用$nextTick确保DOM已更新
        this.$nextTick(() => {
          this.activeSheet = this.jsonData.items[0].sheetName;
        });
      }
    },

    // 显示弹窗
    showModal(fileId) {
        this.fileId = fileId;
        this.loadData();
        document.body.style.overflow = 'hidden';
    },

    // 隐藏弹窗
    async hideModal() {
      let isSave = await this.checkData();
      this.showHistory = false;
      if(isSave){
        this.$confirm(this.$t('excel.confirmSave'), this.$t('excel.tips'), {
          confirmButtonText: this.$t('excel.confirm'),
          cancelButtonText: this.$t('excel.cancel'),
          type: 'warning'
        }).then(() => {
          console.log("数据有修改");
          this.saveDraft()
          this.isVisible = false;
          this.selectedRows = {};
        }).catch(() => {
          // 用户点击取消，不执行任何操作
          this.isVisible = false;
          this.selectedRows = {};
        });
      }else{
        this.isVisible = false;
        this.selectedRows = {};
      }
    },

    // 检查数据是否修改
    checkData() {
      if (!this.originalData || !this.jsonData) {
        return false;
      }
      
      // 比较基本属性
      if (this.originalData.filename !== this.jsonData.filename) {
        return true;
      }
      
      if (this.originalData.type_options?.join(',') !== this.jsonData.type_options?.join(',')) {
        return true;
      }
      
      if (this.originalData.activity_options?.join(',') !== this.jsonData.activity_options?.join(',')) {
        return true;
      }
      
      // 比较工作表数量
      if (this.originalData.items?.length !== this.jsonData.items?.length) {
        return true;
      }
      
      // 比较每个工作表
      for (let i = 0; i < this.jsonData.items?.length; i++) {
        const currentSheet = this.jsonData.items[i];
        const originalSheet = this.originalData.items[i];
        
        if (!originalSheet) {
          return true;
        }
        
        // 比较工作表名称
        if (currentSheet.sheetName !== originalSheet.sheetName) {
          return true;
        }
        
        // 比较表头
        if (currentSheet.headers?.join(',') !== originalSheet.headers?.join(',')) {
          return true;
        }
        
        // 比较数据行数
        if (currentSheet.data?.length !== originalSheet.data?.length) {
          return true;
        }
        
        // 比较每行数据
        for (let j = 0; j < currentSheet.data?.length; j++) {
          const currentRow = currentSheet.data[j];
          const originalRow = originalSheet.data[j];
          
          if (!originalRow) {
            return true;
          }
          
          // 比较每个字段的值
          for (const header of currentSheet.headers) {
            const currentValue = currentRow[header] || '';
            const originalValue = originalRow[header] || '';
            
            if (currentValue.toString().trim() !== originalValue.toString().trim()) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
}
</script>

<style scoped>
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.excel_container {
    position: fixed;
    /* top: 50%; */
    /* right: 50%; */
    right: 20px;
    top:26px;
    /* transform: translate(-50%, -50%); */
    /* background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%); */
    background: var(--global-background);
    width: 1200px;
    /* height: 750px; */
    height: calc(100vh - 52px);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;
    padding: 20px;
    transition: all 0.5s;

    .excel_header_view{
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 20px!important;
      display: flex;
      flex-direction: column;
      padding: 20px;

      .excel_header_view_tite{
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;

        .el-icon-circle-close{
          font-size: 24px;
          cursor: pointer;
          float: right;
        }
      }

      .el-tabs{
        overflow-y: hidden; /* 禁用el-tabs的垂直滚动 */
        padding-right: 0; /* 移除滚动条预留空间 */

        .excel_table{
          flex: 1;
          overflow-y: auto;
          padding-right: 5px; /* 为滚动条预留空间，避免内容被遮挡 */
          scrollbar-width: thin;
          scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
          max-height: calc(100vh - 400px);
          height: auto;

          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background-color: rgba(117, 117, 117, 0.5);
            border-radius: 4px;
            border: 2px solid transparent;
            background-clip: content-box;
          }

          .description-cell {
            max-width: 200px; /* 设置最大宽度 */
            white-space: nowrap; /* 防止文本换行 */
            overflow: hidden; /* 隐藏溢出部分 */
            text-overflow: ellipsis; /* 使用省略号表示溢出部分 */
          }   
        }

        .historyView{
          position: absolute;
          top: 0;
          right: 0;
          width: 280px;
          height: 100%;
          background: #fff;
          display: flex;
          flex-direction: column;

          .historyView_item{
            height: 63px;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 17px;

            &:hover{
              background: rgba(245, 247, 250, 1);
              color: rgba(64, 158, 255, 1);
              cursor: pointer;
            }
          }
        }

        .table-operations{
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .add-row-btn{
            width: max-content;
            padding: 5px 20px;
            border-radius: 16px;
            font-size: 18px;
            cursor: pointer;
            color: #fff;
            /* background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%); */
            background: var(--global-primary);
          }

          .delete-row-btn{
            width: max-content;
            padding: 5px 20px;
            border-radius: 16px;
            font-size: 18px;
            margin-left: 10px;
            cursor: pointer;
            color: #fff;
            /* background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%); */
            background: var(--global-primary);
          }
        }
      }

      .excel_footer_view{
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;


        .download-btn{
          width: max-content;
          padding: 5px 20px;
          border-radius: 16px;
          font-size: 18px;
          cursor: pointer;
          color: #fff;
          /* background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%); */
          background: var(--global-primary);
          margin-right: 15px;
        }

        .download-btn.is-submitting {
          opacity: 0.7;
          cursor: not-allowed;
          /* 可选：加 loading 图标（需配合 icon）  */
        }

        .download-btn.is-loadExcel {
          opacity: 0.7;
          cursor: not-allowed;
          /* 可选：加 loading 图标（需配合 icon */
        }
      }
    }
}

.slide-enter-active {
  animation: slideIn 0.5s forwards;
}

.slide-leave-active {
  animation: slideOut 0.5s forwards;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(100%);
        opacity: 0;
    }
}

::v-deep .el-table .scope-header-row {
  background-color: #e8f4f8 !important;
  font-weight: bold;
}

::v-deep .el-tabs__nav{
  width: 100%;
}

::v-deep .el-tabs__item{
  font-size: 18px;
  border-right: 1px solid #e4e7ed;
}

::v-deep .el-tabs__item.is-disabled{
  color: #303133;
  cursor: pointer;
}

::v-deep .el-tabs__item:last-child{
  position: absolute;
  top: 0;
  right: 0;
}

::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  background-color: transparent!important;
}

.history-loading {
  text-align: center;
  padding: 20px;
  color: #909399;
}

.history-loading .el-icon-loading {
  font-size: 20px;
  margin-right: 8px;
}

.history-empty {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-style: italic;
}
</style>